module.exports = {
  space: ' ',
  nonBreakingSpace: '&nbsp;',
};
